<template>
  <div class="p-relative t-0 w-100">
    <div class="d-flex ai-center bg-test flex-column">
      <div class="d-flex flex-column bg-white content-block p-absolute">
        <router-view></router-view>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import { mapMutations } from "vuex";
export default {
  components: { Footer },
  methods: {
    ...mapMutations("header", ["setHeaderAttr"])
  },
  created() {
    this.setHeaderAttr({
      background: "transprent",
      fixedTop: true
    });
    this.$vuetify.theme.dark = false;
  }
};
</script>

<style lang="sass" scoped>
.bg-test
  background-image: url("/assets/bg/bg_homepage_FAQ_header.png")
  background-size: 100%
  padding-top: 10rem
  min-height: 48.6rem
  margin-bottom: 29.85rem
.content-block
  padding-bottom: 3rem
  z-index: 2
  width: 66rem
</style>
